// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"463702fd","354":"149ff866","418":"53c235a3"}[chunkId] + ".js";
};